module.exports = __webpack_public_path__ + "static/media/GreenBlockRightSideEndState.c70a91ea.svg";